export const CONTACTS = {
  siteName: "ДвериАнт",
  siteUrl: "https://xn--d1acufc5f.xn--p1ai",
  phone: "+7 (978) 011 54 19",
  phoneRaw: "+79780115419",
  phoneLabel: "+7 (978) 011 54 19",
  phone2: "+7 (978) 177 14 43",
  phone2Raw: "+79781771443",
  whatsapp: "+79780115419",
  whatsappUrl: "https://wa.me/79780115419?text=Здравствуйте!%20У%20меня%20вопрос%20по%20дверям",
  email: "dveri-ant@yandex.ru",
  address: {
    full: "г. Севастополь, ул. Отрадная 15/1, 2 этаж (белое здание на парковке Новацентра)",
    city: "Севастополь",
    region: "Севастополь",
    country: "RU",
    street: "ул. Отрадная, 15/1",
    geo: { lat: 44.6167, lng: 33.5254 },
  },
  hours: {
    weekdays: "09:00–18:00",
    saturday: "10:00–15:00",
    sunday: "Выходной",
    weekdayRange: "Пн–Пт: 09:00–18:00",
  },
  social: {
    telegram: "https://t.me/+79780115419",
    vk: "https://vk.com/dveriant",
    instagram: "https://instagram.com/dveriant",
    whatsapp:
      "https://wa.me/79780115419?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A3%20%D0%BC%D0%B5%D0%BD%D1%8F%20%D0%B2%D0%BE%D0%BF%D1%80%D0%BE%D1%81%20%D0%BF%D0%BE%20%D0%B4%D0%B2%D0%B5%D1%80%D1%8F%D0%BC",
  },
  schema: {
    telephone: "+7 (978) 011 54 19",
    openingHours: [
      { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "18:00" },
      { days: ["Saturday"], opens: "10:00", closes: "15:00" },
    ],
  },
} as const
